import {
  IVendorUserManagementRes,
  IVendorDetails,
  IVendorDetailsPut,
  IDropdownResponse,
  IEditableDropdown
} from '../models';
import axios from '../helpers/axios';
import { logError } from '../services';

export const getVendorManagementUsers = async (
  vendorId?: string | number,
  filters?: {
    name?: string;
    page?: number;
    perPage?: number | string;
    sortBy?: string;
    sortDirection?: string;
  }
): Promise<IVendorUserManagementRes> => {
  try {
    const { data } = await axios.get(`/api/vendor-user-management/vendor/${vendorId}/users`, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getVendorManagementUsers failed');
    return Promise.reject(error);
  }
};

export const getAnyVendorConfigured = async (): Promise<any> => {
  try {
    const { data } = await axios.get(`/api/vendor-user-management/any-vendor-configured`);
    return data;
  } catch (error) {
    logError({ error }, 'getAnyVendorConfigured failed');
    return Promise.reject(error);
  }
};

export const vendorResetPassword = async (
  vendorId: string | number,
  personId: string | number
): Promise<any> => {
  try {
    const { data } = await axios.put(
      `/api/vendor-user-management/vendor/${vendorId}/user/${personId}/reset-password`
    );
    return data;
  } catch (error) {
    logError({ error }, 'vendorResetPassword failed');
    return Promise.reject(error?.response?.data);
  }
};

export const vendorResetTwoFactor = async (
  vendorId: string | number,
  personId: string | number
): Promise<any> => {
  try {
    const { data } = await axios.put(
      `/api/vendor-user-management/vendor/${vendorId}/user/${personId}/reset-two-factor`
    );
    return data;
  } catch (error) {
    logError({ error }, 'vendorResetTwofactor failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getVendorUserManagementVendors = async (): Promise<IDropdownResponse | any> => {
  try {
    const { data } = await axios.get(`/api/vendor-user-management/vendors`, {
      headers: { 'Content-Type': 'application/json' }
    });
    return data;
  } catch (error) {
    logError(error, 'getVendorUserManagementVendors failed');
    return Promise.reject(error.response.data);
  }
};

export const getVendorUserManagementVendorsUser = async (
  personId: number | string
): Promise<IEditableDropdown[] | any> => {
  try {
    const { data } = await axios.get(`/api/vendor-user-management/vendors/user/${personId}`, {
      headers: { 'Content-Type': 'application/json' }
    });
    return data;
  } catch (error) {
    logError(error, 'getVendorUserManagementVendorsUser failed');
    return Promise.reject(error.response.data);
  }
};

export const createVendorUserManagementVendorsUser = async (
  payload: IVendorDetailsPut
): Promise<any> => {
  try {
    return await axios.post(`/api/vendor-user-management/user`, payload);
  } catch (error) {
    logError({ error }, 'createVendorUserManagementVendorsUser failed');
    return Promise.reject(error?.response?.data);
  }
};

export const updateVendorUserManagementVendorsUser = async (
  personId: number,
  payload: IVendorDetailsPut
): Promise<any> => {
  try {
    return await axios.put(`/api/vendor-user-management/user/${personId}`, payload);
  } catch (error) {
    logError({ error }, 'updateVendorUserManagementVendorsUser failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getVendorUserManagementVendorUser = async (
  vendorId: number,
  personId: number
): Promise<IVendorDetails | any> => {
  try {
    const { data } = await axios.get(
      `/api/vendor-user-management/vendor/${vendorId}/user/${personId}`,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    );
    return data;
  } catch (error) {
    logError(error, 'getVendorUserManagementVendorUser failed');
    return Promise.reject(error.response.data);
  }
};
